export default "__VITE_ASSET__DSnXARz8__"